import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface IconAvatarBotProps extends SvgIconProps {}

const IconAvatarBot: React.FC<IconAvatarBotProps> = ({ ...rest }) => (
  <SvgIcon viewBox="0 0 18 18" {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 3.93699C10.3626 3.71497 11 2.93192 11 2C11 0.895431 10.1046 0 9 0C7.89543 0 7 0.895431 7 2C7 2.93192 7.63739 3.71497 8.5 3.93699V5.01249C4.31463 5.22219 1 8.04659 1 11.5C1 15.0899 4.58172 18 9 18C13.4183 18 17 15.0899 17 11.5C17 8.04659 13.6854 5.22219 9.5 5.01249V3.93699ZM5 9C3.89543 9 3 9.89543 3 11C3 12.1046 3.89543 13 5 13H13C14.1046 13 15 12.1046 15 11C15 9.89543 14.1046 9 13 9H5ZM7 11C7 11.5523 6.55228 12 6 12C5.44772 12 5 11.5523 5 11C5 10.4477 5.44772 10 6 10C6.55228 10 7 10.4477 7 11ZM12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12Z"
      fill="white"
    />
  </SvgIcon>
);

export default IconAvatarBot;
